import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@rsos/components/capstone/base';
import { useLazyAcceptRcsConversationQuery } from '@rsos/reduxDataStore/src/features/rcs/rcsApi';
import { useSelectedRcsConversation } from '@rsos/reduxDataStore/src/features/rcs/rcsSelectors';
import { selectUserOrgByApp } from '@rsos/sinatra';
import {
  trackAcceptRCSChat,
  trackAcceptRCSChatResponse,
} from '../rcsTrackings';
import { AcceptDeclineContainer, AcceptButton } from './RcsChat.styles';

const RcsAcceptDeclineChat = () => {
  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );

  const orgName = useSelector(
    state =>
      selectUserOrgByApp(
        state.sinatra,
        state.sinatra.user.currentRole.application,
      ).name,
  );

  // get RCS conversation metadata for tracking
  const rcsConversation = useSelectedRcsConversation(selectedCallerID);
  const conversationId = useMemo(
    () => rcsConversation?.data?.conversation_id,
    [rcsConversation],
  );
  const sessionId = useMemo(
    () => rcsConversation?.data?.session_id,
    [rcsConversation],
  );

  const [triggerAcceptRcsConversation] = useLazyAcceptRcsConversationQuery();

  const handleAcceptConversation = useCallback(() => {
    trackAcceptRCSChat({
      conversationId,
      sessionId,
    });
    triggerAcceptRcsConversation({
      callerID: selectedCallerID,
      orgName,
    })
      .unwrap()
      .then(() => {
        trackAcceptRCSChatResponse({
          responseSuccess: true,
          conversationId,
          sessionId,
        });
      })
      .catch(() => {
        trackAcceptRCSChatResponse({
          responseSuccess: false,
          conversationId,
          sessionId,
        });
      });
  }, [
    selectedCallerID,
    orgName,
    triggerAcceptRcsConversation,
    conversationId,
    sessionId,
  ]);

  return (
    <AcceptDeclineContainer>
      <Box
        alignSelf="center"
        borderRadius="0 0 5px 5px"
        horizontal
        width="100%"
        style={{ gap: '10px' }}
      >
        <AcceptButton
          btnType="primary"
          isLoadingProp={false}
          noMargin
          onClick={handleAcceptConversation}
          size="med"
          grow
        >
          Accept
        </AcceptButton>
      </Box>
    </AcceptDeclineContainer>
  );
};

export default RcsAcceptDeclineChat;
